<template>
	<div>
		<transition
			name="fade"
			enter-active-class="animated fadeIn"
			leave-active-class="animated fadeOut"
		>
			<b-container>
				<h3
					v-if="isSurety && routeName == 'firstSuretyJobInfo'"
					class="text-center  mb-5 textBlue"
				>
					{{ $t("register.firstSuretyJobInfo") }}
				</h3>
				<h3
					v-if="isSurety && routeName == 'secondSuretyJobInfo'"
					class="text-center  mb-5 textBlue"
				>
					{{ $t("register.secondSuretyJobInfo") }}
				</h3>
				<h3 v-if="!isSurety" class="text-center  mb-5 textBlue">
					{{ $t("register.jobInfo") }}
				</h3>
				<b-form @submit.stop.prevent="onSubmit">
					<!-- ================================= Job Class $ Job STATUS  ============================== -->
					<b-row align-h="between">
						<!--------------------------------- Job Class -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_class_group"
								:label="$t('register.jobClassLabel')"
								label-cols-sm="5"
								label-for="job_class"
								:state="validateState('job_class')"
							>
								<b-form-select
									v-model="$v.form.job_class.$model"
									:options="job_class_options"
									:state="validateState('job_class')"
									aria-describedby="job_class-live-feedback"
									class="form-control"
								></b-form-select>
								<b-form-invalid-feedback id="job_class-live-feedback">
									{{ $t("validation.requiredToFill") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<!--------------------------------- job status -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_status_group"
								:label="$t('register.jobStatusLable')"
								label-cols-sm="5"
								label-for="job_status"
								:state="validateState('job_status')"
							>
								<b-form-select
									id="job_status"
									v-model="$v.form.job_status.$model"
									:state="validateState('job_status')"
									aria-describedby="job_status-live-feedback"
									class="form-control"
								>
									<b-form-select-option
										value="0"
										v-if="form.job_class == '3'"
										>{{
											$t("register.jobStatus.temporal")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="1"
										v-show="form.job_class == '3'"
										>{{ $t("register.jobStatus.always") }}</b-form-select-option
									>
									<b-form-select-option
										value="2"
										v-show="form.job_class == '3'"
										>{{
											$t("register.jobStatus.withOutContract")
										}}</b-form-select-option
									>

									<b-form-select-option
										value="3"
										v-show="form.job_class == '1'"
										>{{
											$t("register.jobStatus.withLicense")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="4"
										v-show="form.job_class == '1'"
										>{{
											$t("register.jobStatus.withOutLicense")
										}}</b-form-select-option
									>

									<b-form-select-option
										value="5"
										v-show="form.job_class == '0'"
										>{{
											$t("register.jobStatus.officialStaff")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="6"
										v-show="form.job_class == '0'"
										>{{
											$t("register.jobStatus.contractStaff")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="7"
										v-show="form.job_class == '0'"
										>{{
											$t("register.jobStatus.serviceStaff")
										}}</b-form-select-option
									>

									<b-form-select-option
										value="8"
										v-show="(form.job_class == '2') | (form.job_class == '5')"
										>{{
											$t("register.jobStatus.taminOrg")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="9"
										v-show="(form.job_class == '2') | (form.job_class == '5')"
										>{{
											$t("register.jobStatus.retiredOrg")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="10"
										v-show="(form.job_class == '2') | (form.job_class == '5')"
										>{{
											$t("register.jobStatus.armyOrg")
										}}</b-form-select-option
									>

									<b-form-select-option
										value="11"
										v-show="form.job_class == '4'"
										>{{
											$t("register.jobStatus.official")
										}}</b-form-select-option
									>
									<b-form-select-option
										value="12"
										v-show="form.job_class == '4'"
										>{{ $t("register.jobStatus.others") }}</b-form-select-option
									>
								</b-form-select>
								<b-form-invalid-feedback id="job_status-live-feedback">
									{{ $t("validation.requiredToFill") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- ================================= JOB & job_workplace ============================== -->
					<b-row align-h="between">
						<!--------------------------------- job -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_group"
								:label="$t('register.jobLable')"
								label-for="job"
								label-cols-sm="5"
							>
								<b-form-input
									id="job"
									type="text"
									v-model="$v.form.job.$model"
									:state="validateState('job')"
									aria-describedby="job-live-feedback"
								></b-form-input>
								<b-form-invalid-feedback id="job_address-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<!--------------------------------- job_workplace -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_workplace_group"
								:label="$t('register.jobWorkplace')"
								label-cols-sm="5"
								label-for="job_workplace"
							>
								<b-form-input
									id="job_workplace"
									type="text"
									v-model="$v.form.job_workplace.$model"
									class="form-control"
									:state="validateState('job_workplace')"
									aria-describedby="job_workplace-live-feedback"
								></b-form-input>
								<b-form-invalid-feedback id="job_workplace-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- ================================= job_phone_n‍umber $ job_address ============================== -->
					<b-row align-h="between">
						<!--------------------------------- job_phone_n‍umber -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_phone_n‍umber_group"
								type="tel"
								:label="$t('register.jobPhoneNumber')"
								label-cols-sm="5"
								label-for="job_phone_n‍umber"
							>
								<b-form-input
									id="job_phone_n‍umber"
									type="number"
									v-model="$v.form.job_phone_number.$model"
									:state="validateState('job_phone_number')"
									aria-describedby="job_phone_n‍umber-live-feedback"
								></b-form-input>
								<b-form-invalid-feedback
									id="job_phone_n‍umber-live-feedback"
									v-show="!$v.form.job_phone_number.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="owner_mobile_number-live-feedback"
									v-show="
										!$v.form.job_phone_number.minLength |
											!$v.form.job_phone_number.maxLength
									"
								>
									{{ $t("validation.phoneInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<!--------------------------------- job_address -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="job_address_group"
								:label="$t('register.jobAddress')"
								label-for="job_address"
								label-cols-sm="5"
							>
								<b-form-textarea
									id="job_address"
									type="number"
									v-model="$v.form.job_address.$model"
									aria-describedby="job_address-live-feedback"
									:state="validateState('job_address')"
									rows="5"
									size="sm"
								></b-form-textarea>
								<b-form-invalid-feedback id="job_address-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- ================================= estimate_income ============================== -->
					<b-row align-h="between">
						<!--------------------------------- estimate_income -----------------------------------------  -->
						<b-col md="6">
							<b-form-group
								id="estimate_income_group"
								type="tel"
								:label="$t('register.estimateIncome')"
								label-cols-sm="5"
								label-for="estimate_income"
							>
								<b-form-input
									id="estimate_income"
									type="number"
									v-model="$v.form.estimate_income.$model"
									:state="validateState('estimate_income')"
									aria-describedby="estimate_income-live-feedback"
								></b-form-input>
								<b-form-invalid-feedback
									id="estimate_income-live-feedback"
									v-show="!$v.form.estimate_income.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="owner_mobile_number-live-feedback"
									v-show="!$v.form.estimate_income.maxLength"
								>
									{{ $t("validation.amountInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<b-col md="6"> </b-col>
					</b-row>

					<!-- end of rental section -->

					<b-row align-h="center" v-show="!edit">
						<b-button
							type="submit"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							>{{ $t("register.save") }}</b-button
						>
					</b-row>
					<b-row align-h="center" v-show="edit">
						<b-button
							type="button"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							@click.prevent="updateCustomer"
							>{{ $t("register.edit") }}</b-button
						>
					</b-row>
				</b-form>
			</b-container>
		</transition>
	</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import { validationMixin } from "vuelidate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	mixins: [validationMixin],
	data() {
		return {
			isSurety: false,
			edit: false,
			form: {
				job: "",
				job_workplace: "",
				job_phone_number: "",
				job_class: "",
				job_status: "",
				job_address: "",
				estimate_income: "",
				mobile_number: "",
				melli_code: "",
			},

			job_class_options: [
				{ value: "3", text: this.$t("register.jobClass.private") },
				{ value: "1", text: this.$t("register.jobClass.libre") },
				{ value: "0", text: this.$t("register.jobClass.govermental") },
				{ value: "4", text: this.$t("register.jobClass.army") },
				{ value: "5", text: this.$t("register.jobClass.Retired") },
				{ value: "2", text: this.$t("register.jobClass.Pensioner") },
			],

			job_status_options: [{ value: "", text: this.$t("register.gobStatus.") }],
		};
	},
	props: ["routeName"],
	watch: {
		routeName: {
			handler: function() {
				this.checkRouteName();
			},
		},
	},
	validations: {
		form: {
			job: { required },
			job_workplace: { required },
			job_phone_number: {
				required,
				minLength: minLength(11),
				maxLength: maxLength(11),
			},
			job_class: { required },
			job_status: { required },
			job_address: { required },
			estimate_income: {
				required,
				maxLength: maxLength(3),
				minLength: minLength(2),
			},
		},
		computed: {
			melliCodeInvalid() {
				return "این فیلد را کامل کنید!";
			},
		},
	},
	mounted() {
		this.checkRouteName();
	},
	methods: {
		checkRouteName() {
			if (
				this.routeName == "firstSuretyJobInfo" ||
				this.routeName == "SuppliersCustomerEditFirstSuretyJobInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = true;
				this.getFirstSurety();
			} else if (
				this.routeName == "secondSuretyJobInfo" ||
				this.routeName == "SuppliersCustomerEditSecondSuretyJobInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = true;
				this.getSecondSurety();
			} else if (
				this.routeName == "editJobInfo" ||
				this.routeName == "SupplierEditCustomerJobInfo"
			) {
				this.isRegisterCompleted = true;
				this.getCustomer();
			} else {
				this.isRegisterCompleted = false;
				this.getCustomer();
			}
		},
		onSubmit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("updateCustomer", this.form)
					.then((response) => {
						console.log(response);
						load.hide();
						if (!this.isRegisterCompleted) {
							this.$router.push({ name: "registerPage" });
						}
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},
		getCustomer() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getCustomer")
				.then((response) => {
					console.log(response);
					load.hide();
					this.form = response.body;
					this.edit = true;
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.error);
					load.hide();
					this.edit = false;
				});
		},
		getFirstSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getFirstSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						this.form.melli_code = response.body.melli_code;
						this.form.mobile_number = response.body.mobile_number;
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						// this.isSuretyRegistered=true

						this.checkResponse(response);
					} else {
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/firstSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditFirstSuretyIdentityInfo",
							});
						}

						load.hide();
					}
				})
				.catch((err) => {
					if (err.status == 404) {
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/firstSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditFirstSuretyIdentityInfo",
							});
						}
					}
					if (err.status != 404) {
						this.$noty.error(err.body.error);
					}
					load.hide();
					this.edit = false;
				});
		},
		getSecondSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSecondSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						this.form.melli_code = response.body.melli_code;
						this.form.mobile_number = response.body.mobile_number;
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						// this.isSuretyRegistered=true

						this.checkResponse(response);
					} else {
						//this.$router.push("/customer/secondSuretyIdentityInfo")
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/secondSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditSecondSuretyIdentityInfo",
							});
						}
						load.hide();
					}
				})
				.catch((err) => {
					if (err.status == 404) {
						//this.$router.push("/customer/secondSuretyIdentityInfo")
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/secondSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditSecondSuretyIdentityInfo",
							});
						}
					}

					if (err.status != 404) {
						this.$noty.error(err.body.error);
					}
					load.hide();
					this.edit = false;
				});
		},
		updateCustomer() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				let form = {
					job: this.form.job,
					job_workplace: this.form.job_workplace,
					job_phone_number: this.form.job_phone_number,
					job_class: this.form.job_class,
					job_status: this.form.job_status,
					job_address: this.form.job_address,
					estimate_income: this.form.estimate_income,
				};
				console.log("form: ", form);
				if (this.isSurety) {
					form.melli_code = this.form.melli_code;
					form.mobile_number = this.form.mobile_number;
					this.$store
						.dispatch("updateSurety", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
							//this.$router.push({ name: "registerPage" });
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				} else {
					this.$store
						.dispatch("updateCustomer", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
							if (!this.isRegisterCompleted) {
								this.$router.push({ name: "registerPage" });
							}
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				}
			}
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},
	},
	components: {
		datePicker: VuePersianDatetimePicker,
	},
};
</script>

<style>
.was-validated .form-control:valid,
.form-control.is-valid {
	background-image: none;
	padding-right: 0.4rem !important;
	padding-left: 0.4rem !important;
}
.was-invalidated .form-control:invalid,
.form-control.is-invalid {
	background-image: none;
	padding-right: 0.4rem !important;
	padding-left: 0.4rem !important;
}
.custom-select {
	padding: 0px;
}
/* textarea {
	padding-top: 3px;
}
textarea:focus {
	padding-top: 3px;
} */
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css"></style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
